import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface ResultPageHeaderProps {
  /** Where the breadcrumb root goes (the results list). */
  backTo: string;
  backLabel: string;
  title: string;
  /** "3 Nov · 2 h 41 min · attempt 4" */
  meta?: string;
  /** Share, retake, analysis. */
  actions?: React.ReactNode;
}

/** The title block every result opens with: breadcrumb, h1, a one-line meta and the page actions. */
export function ResultPageHeader({ backTo, backLabel, title, meta, actions }: ResultPageHeaderProps) {
  return (
    <header className="mb-5 mt-1">
      <nav aria-label={backLabel} className="flex items-center gap-2 text-xs text-[#646D84]">
        <Link to={backTo} className="inline-flex items-center gap-1 rounded-md hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#10182B]">
          <ChevronLeft className="h-3.5 w-3.5" aria-hidden />
          {backLabel}
        </Link>
        <span aria-hidden>/</span>
        <b aria-current="page" className="min-w-0 truncate font-semibold text-foreground">{title}</b>
      </nav>
      <div className="mt-3 flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <h1 className="font-display text-2xl font-extrabold leading-[1.15] tracking-[-0.04em] text-foreground lg:text-[32px]">{title}</h1>
          {meta && <p className="mt-1.5 text-[13px] text-[#4B5468] lg:text-sm">{meta}</p>}
        </div>
        {actions && <div className="flex flex-wrap gap-2.5">{actions}</div>}
      </div>
    </header>
  );
}
